export const formatCardNumber = (cardNumber: string): string =>
  cardNumber.length !== 19
    ? cardNumber
    : cardNumber.replace(/(\w{6})(\w{4})(\w{9})/, "$1-$2-$3");
